import { useState } from "react";
import { useEffect } from "react";
import { BadgeCheck, WifiOff } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/ui/tooltip";

export function RealtimeStatusIndicator() {
    const [status, setStatus] = useState<'connected' | 'reconnecting' | 'disconnected'>('connected');

    useEffect(() => {
        const handleOnline = () => setStatus('connected');
        const handleOffline = () => setStatus('disconnected');

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <TooltipProvider delayDuration={300}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <div className="flex items-center gap-1.5 cursor-help">
                        <div className={`h-1.5 w-1.5 rounded-full ${status === 'connected' ? 'bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.4)]' : 'bg-red-500'}`} />
                        <span className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground/60">Live</span>
                    </div>
                </TooltipTrigger>
                <TooltipContent side="bottom" className="text-xs">
                    {status === 'connected' ? "Connected to UptimeWing Engine" : "Connection lost"}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
